import { Check } from "lucide-react";
import { DIFF_CONTENT, DIFF_EXPERIENCE, DIFF_IMAGES } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

const Group = ({ title, items, image, testid, highlight }) => (
  <div
    className={`h-full rounded-3xl overflow-hidden flex flex-col transition-all duration-500 ${
      highlight ? "glass-static ring-glow" : "glass-static"
    }`}
    data-testid={testid}
  >
    {/* Foto de topo */}
    <div className="relative h-48 sm:h-56 overflow-hidden group">
      <img
        src={image}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-base via-brand-base/30 to-transparent" />
      <h3 className="absolute bottom-4 left-6 sm:left-8 font-display font-extrabold uppercase text-white text-2xl sm:text-3xl drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)]">
        {title}
      </h3>
    </div>

    {/* Lista com ícones · padrão anterior */}
    <ul className="flex-1 space-y-4 p-6 sm:p-8">
      {items.map((t, i) => (
        <li key={i} className="flex items-start gap-3.5" data-testid={`${testid}-item-${i}`}>
          <span className="mt-0.5 h-6 w-6 shrink-0 rounded-full border border-white/20 bg-white/[0.08] backdrop-blur-sm flex items-center justify-center">
            <Check size={13} className="text-white/85" />
          </span>
          <span className="text-brand-silver/90 leading-relaxed">{t}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default function Diferenciais() {
  return (
    <section id="diferenciais" className="relative py-20 sm:py-28 bg-gradient-to-b from-brand-royal/25 via-brand-elev/30 to-brand-base border-y border-white/10" data-testid="diferenciais-section">
      <div className="absolute inset-0 bg-[radial-gradient(800px_400px_at_50%_30%,rgba(0,142,255,0.08),transparent_70%)] pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="heading-lg" data-testid="diferenciais-heading">
            <MaskLine inView>
              Diferenciais <span className="text-gradient-blue">no PS27</span>
            </MaskLine>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-5 sm:gap-6 items-stretch">
          <Reveal className="h-full">
            <Group title="Conteúdo" items={DIFF_CONTENT} image={DIFF_IMAGES.content} testid="diff-content" highlight={false} />
          </Reveal>
          <Reveal delay={0.12} className="h-full">
            <Group title="Experiências" items={DIFF_EXPERIENCE} image={DIFF_IMAGES.experience} testid="diff-experience" highlight />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
